const config = {
  // uncomment for production bundle
  apiUrl: '/ajax/',

  // uncomment when testing in developer or production mode  
  // apiUrl: '/api/ajax.php',

  // Явное задание URL (потребует прописывания Access-Control-Allow-Origin на сервере)
  // apiUrl: 'http://alsagor.local/ajax/',
}

export default config;